var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "columns contact-details is-vcentered" }, [
      _c(
        "div",
        {
          staticClass:
            "column is-narrow is-hidden-touch is-hidden-desktop-only",
        },
        [
          _c("avatar", {
            attrs: {
              image: _vm.user.image,
              cropped: true,
              alt: _vm.fullName,
              size: _vm.size,
            },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "column" }, [
        _c("p", {
          staticClass: "title is-4 is-marginless",
          domProps: { textContent: _vm._s(_vm.fullName) },
        }),
        _vm.jobtitle
          ? _c("p", {
              staticClass: "subtitle is-6 is-marginless",
              domProps: { textContent: _vm._s(_vm.jobtitle) },
            })
          : _vm._e(),
        _vm.showDetails
          ? _c(
              "p",
              { staticClass: "user-details" },
              [
                _vm.emailLink
                  ? _c("a", { attrs: { href: _vm.emailLink } }, [
                      _vm._v(_vm._s(_vm.user.email)),
                    ])
                  : _vm._e(),
                _vm.emailLink && _vm.phoneLink ? _c("br") : _vm._e(),
                _vm.phoneLink
                  ? _c("dc-icon", {
                      attrs: { icon: "phone-alt", library: "fas" },
                    })
                  : _vm._e(),
                _vm.phoneLink
                  ? _c("a", { attrs: { href: _vm.phoneLink } }, [
                      _vm._v(_vm._s(_vm.user.phone)),
                    ])
                  : _vm._e(),
                _vm.pagerLink && _vm.phoneLink ? _c("br") : _vm._e(),
                _vm.pagerLink
                  ? _c("a", { attrs: { href: _vm.pagerLink } }, [
                      _vm._v(_vm._s(_vm.user.pagernumber)),
                    ])
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _vm.showViewLink
          ? _c(
              "p",
              [
                _c(
                  "router-link",
                  {
                    staticClass: "button is-small",
                    attrs: { to: "/users/view/" + _vm.user.id },
                  },
                  [_vm._v("View profile")]
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }